
import './style.less'

import { h, Fragment } from 'preact'
import classnames from 'classnames'


const arrayChunk = (array, n) => {
    return Array.from(Array(Math.ceil(array.length/n)), (_,i)=>array.slice(i*n,i*n+n))
}


export default ({ children : allChildren, ...props }) => {

	// limit to 7 children
	if (!Array.isArray(allChildren) || !allChildren.length) return <div></div>
	const children = [allChildren].flat().splice(0, 7)
	const first = children.shift()
	const chunked = arrayChunk(children, 2)
	const desktopClass = (allChildren.length >= 2) && 'staggered-desktop-sufficient'
	const mobileClass = (allChildren.length > 2) && 'staggered-mobile-sufficient'

	const classes = classnames(
		'staggered',
		desktopClass,
		mobileClass,
		props.class,
		props.className
	)

	return (
		<div class={classes}>

			{/* first row only has one child */}
			<div class="staggered__row">
				<div class="staggered__item">
					<div class="staggered__item__inner">
						{first}
					</div>
				</div>
			</div>

			{/* the rest are chunked into two, with a max of 3 rows */}

			{chunked.map(chunk => 
				<div class="staggered__row">
					{chunk.map(item => 
						<div class="staggered__item">
							<div class="staggered__item__inner">
								{item}
							</div>
						</div>
					)}
				</div>
			)}
		</div>
	)
}